/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Turn_OffInputs */

const en_push_turn_off = /** @type {(inputs: Push_Turn_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn off for this device`)
};

/**
* | output |
* | --- |
* | "Turn off for this device" |
*
* @param {Push_Turn_OffInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const push_turn_off = /** @type {((inputs?: Push_Turn_OffInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Turn_OffInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_push_turn_off(inputs)
});